module.exports = __webpack_public_path__ + "static/fonts/TikTokSans-Bold.65eba471.ttf";